// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	TypeDropdown: 'type-dropdown',
	OtherTypeInput: 'other-type-input',
	TypeRadioGroup: 'type-radio-group',
	CondominiumTypeRadioGroup: 'condominium-type-radio-group',
} as const;
